import { useAppDispatch, useAppSelector } from '@/app/hooks'
import {
  fetchFeaturePlaylists,
  playlistBeezer
} from '@/features/playlist/playlistSlice'
import {
  SelectAuth,
  setAccessToken,
  setAuthenticated,
  userLogin
} from '@/features/spotifyAuth/authSlice'
import { spotifyApi } from '@/services/spotify'
import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { RouterPrivate } from './RouterPrivate'
import { RouterPublic } from './RouterPublic'
import { useAuthStore } from '@/zustand/useAuthGoogle'

export const RouterContainer = () => {
  const { isGuest } = useAppSelector(SelectAuth)
  const dispatch = useAppDispatch()
  const [token, setToken] = useState(window.localStorage.getItem('token'))
  const user = useAuthStore((state) => state.user)

  useEffect(() => {
    const hash = window.location.hash
    window.location.hash = window.location.hash.replace(hash, '')

    if (hash) {
      setToken(hash.substring(1).split('&')[0].split('=')[1])
    }

    if (token) {
      dispatch(setAccessToken(token))
      spotifyApi.setAccessToken(token)
      dispatch(userLogin())
      dispatch(fetchFeaturePlaylists())
      dispatch(setAuthenticated(true))
      window.localStorage.setItem('token', token)
      console.debug('is Auth Spotify')
      return
    }

    if (isGuest) {
      dispatch(playlistBeezer())
      console.debug('is Guest')
      return
    }

    console.debug(isGuest, user)
  }, [dispatch, token, isGuest, user])

  return (
    <BrowserRouter>
      {token || isGuest || user ? <RouterPrivate /> : <RouterPublic />}
    </BrowserRouter>
  )
}
